import { render, staticRenderFns } from "./SMKProduct.vue?vue&type=template&id=265bf08b&scoped=true&"
import script from "./SMKProduct.vue?vue&type=script&lang=js&"
export * from "./SMKProduct.vue?vue&type=script&lang=js&"
import style0 from "./SMKProduct.vue?vue&type=style&index=0&id=265bf08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265bf08b",
  null
  
)

export default component.exports